import { theme } from 'components/Theme/main';
import { SkeletonTheme } from 'react-loading-skeleton';
import { ThemeProvider } from 'styled-components';

/**
 * This global provider is used primary for styleguidist as wrapper.
 */
const ShopsysGlobalProvider: FC = ({ children }) => {
    return (
        <SkeletonTheme baseColor="#eeeeee" duration={1} highlightColor="#e3e4ec">
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </SkeletonTheme>
    );
};

/* @component */
export default ShopsysGlobalProvider;
